import { SidekickSupportedTms } from '@shared/generated/graphql';
import { EntityInfo, SupportedEntityType, TMSPageInfo } from './types';

export function getTurvoPageInfo(url: string): TMSPageInfo {
  return {
    pageType: 'tms',
    tms: SidekickSupportedTms.TURVO,
    entityInfo: getEntityInfo(url),
  };
}

function getEntityInfo(url: string): EntityInfo[] {
  // NOTE(mike): For now, we look for entity at a time.
  const shipmentPattern = /shipments\/(\d+)/;
  const shipmentMatch = url.match(shipmentPattern);
  if (shipmentMatch) {
    return [
      {
        entityType: SupportedEntityType.SHIPMENT,
        entityReference: shipmentMatch[1],
      },
    ];
  }
  return [];
}
